export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setNewSuppliersGroup(state, { payload }) {
    state.suppliers_groups = [...state.suppliers_groups, ...[payload]];
  },

  delProperty(state, { property }) {
    state.suppliers_groups = state.suppliers_groups.filter(el => el.id !== property);
  },
};
